import React from "react";
import { Reveal } from "@/components/motion/Reveal";

// Looping brand strip — 8 partner brands we manufacture for.
const BRANDS_IMG =
  "https://customer-assets.emergentagent.com/job_athletic-fuel-3/artifacts/wlmeun22_Captura%20de%20pantalla%202026-07-09%20a%20las%2013.18.30.webp";

export default function Brands() {
  return (
    <section id="marcas" className="relative bg-[#F8FAFC] border-y border-slate-200 py-6 md:py-8 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="text-xs uppercase tracking-[0.3em] text-[#0A84E2] font-semibold text-center">
            Marcas con las que trabajamos
          </div>
          <p className="mt-3 text-center text-slate-500 text-sm md:text-base max-w-xl mx-auto">
            Fabricamos y desarrollamos producto para marcas líderes de nutrición deportiva.
          </p>
        </Reveal>
      </div>

      <div className="relative mt-12 max-w-7xl mx-auto px-6 md:px-12" data-testid="brands-carousel">
        <img
          src={BRANDS_IMG}
          alt="Marcas fabricadas por Global Nutralabs"
          className="w-full h-auto object-contain opacity-50"
        />
      </div>
    </section>
  );
}
